export default __webpack_public_path__ + "static/media/469.ad3c53e4.gif";